module.exports = __webpack_public_path__ + "img/facebook.5d6112e0.png";